import axios from 'axios';
import ENV from '../constants/envConstants';

export const refreshJWT = async (refreshToken) => {
    const token = await axios.post(ENV.BACKEND_URL + '/restaurants/users/token/refresh/', {refresh: refreshToken}).then((res) => {
        return (res.data.access)
    })
    return token
}

export const getMenuUrl = (placeId) => {
  return ENV.VISUAL_MENU_URL + "place/" + placeId + "/menu";
};

export const getPreviewUrl = (placeId) => {
  return ENV.VISUAL_MENU_URL + "place/" + placeId + "/menu" + "?preview=true";
};
